/**
 ** Erases all object keys named '__typename' (custom graphql key)
 **/
const getEntityWithoutTypename = graphQLEntity => {
  return !graphQLEntity
    ? null
    : Object.keys(graphQLEntity)
        .filter(key => key !== "__typename")
        .map(key => {
          const value = graphQLEntity[key];
          if (Array.isArray(value)) {
            graphQLEntity[key] = value.map(obj => {
              if (typeof obj === "object" || Array.isArray(obj)) {
                return getEntityWithoutTypename(obj);
              } else {
                return obj;
              }
            });
          } else if (typeof value === "object") {
            graphQLEntity[key] = getEntityWithoutTypename(value);
          }
          return { [key]: graphQLEntity[key] };
        })
        .reduce((result, element) => ({ ...result, ...element }), {});
};

export default getEntityWithoutTypename;
